import { FormControl, FormLabel, styled } from "@mui/material";
import { StyledMarkdown } from "components/utils/StyledMarkdown";
import { TextField, TextFieldProps } from "formik-mui";

interface Props extends TextFieldProps {
  customHelperText?: string;
}
export function FormikTextField(props: Props) {
  const { label, fullWidth, customHelperText, className, ...formProps } = props;
  return (
    <StyledFormControl fullWidth={fullWidth} className={className}>
      {label && (
        <FormLabel>
          <StyledMarkdown content={label?.toString()} />
        </FormLabel>
      )}
      <TextField
        fullWidth={fullWidth}
        {...formProps}
        helperText={customHelperText ? customHelperText : " "}
      />
    </StyledFormControl>
  );
}
const StyledFormControl = styled(FormControl)`
  .MuiFormLabel-root {
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  }
  .MuiFormHelperText-root {
    margin-left: 0;
  }
`;
